export class CustomerModel {
    id: number;
    uniqId: string;
    businessName: string;
    contacts: string;
    internalNotes: string;
    branches: Array<any>;
    costAccountCode: string;
    entityInvoiceName: string;
    invoiceCode: string;
    invoicePrefix: string;
    paymentTerms: number;
    requiredPOD: number;
    isTest: boolean;

    constructor () {
        this.id = 0;
        this.uniqId = '';
        this.businessName = '';
        this.contacts = '';
        this.internalNotes = '';
        this.branches = [];
        this.costAccountCode = '';
        this.entityInvoiceName = '';
        this.invoiceCode = '';
        this.invoicePrefix = '';
        this.paymentTerms = 0;
        this.requiredPOD = 0
        this.isTest = false;
    }

    public static fromJson (json: any): CustomerModel {
        const customer = new CustomerModel;
        Object.assign(customer, {
            id: json.id,
            uniqId: json.uniq_id ?? '',
            businessName: json.business_name ?? '',
            contacts: json.contacts ?? '',
            internalNotes: json.inernal_notes ?? '',
            isTest: json.is_test,
            branches: json.branches.map((branch: any) => {
                return {
                    id: branch.id,
                    uniqId: branch.uniq_id,
                    name: branch.name,
                    contacts: branch.contacts,
                    coordinates: branch.coordinates,
                    internalNotes: branch.internal_notes,
                    postCode: branch.postcode,
                    radius: branch.radius,
                    stateId: branch.state_id,
                    streetAddress: branch.street_address,
                    suburb: branch.suburb,
                    services: branch.services,
                    contractors: branch.contractors || [],
                    placeId: branch.address_place_id,
                    costAccountCode: branch.cost_account_code,
                    entityInvoiceName: branch.entity_invoice_name,
                    invoiceCode: branch.invoice_code,
                    invoicePrefix: branch.invoice_prefix,
                    paymentTerms: branch.payment_terms,
                    requiredPOD: branch.required_pod,
                    managerIds: branch.manager_ids,
                    email: branch.email,
                    pointOfContact: branch.point_of_contact
                };
            })
        });
        return customer;
    }
}